import * as ModalRoot from '@radix-ui/react-dialog';
import { useSubMenu } from '../../SubMenuContext';

import * as Modal from '@radix-ui/react-dialog';
import { forwardRef, ReactNode, ButtonHTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

interface ModalProps {
	children: ReactNode;
	onOpenChange?: (state: boolean) => void;
}

export const ModalVideo = ({ children, ...props }: ModalProps extends ModalRoot.DialogProps ? ModalRoot.DialogProps : null) => {
	const { clearSub } = useSubMenu();

	return (
		<ModalRoot.Root
			onOpenChange={(state) => {
				if (props.onOpenChange) props.onOpenChange(state);
				if (!state) clearSub?.();
			}}
			{...props}>
			{children}
		</ModalRoot.Root>
	);
};

interface ModalProps extends Modal.DialogContentProps {
	children: ReactNode;
	contentClass?: string;
}
const DialogOverlay = forwardRef<React.ElementRef<typeof Modal.Overlay>, React.ComponentPropsWithoutRef<typeof Modal.Overlay>>(({ className, ...props }, ref) => (
	<Modal.Overlay ref={ref} className={twMerge('fixed inset-0 z-50 bg-gray-500/75 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0', className)} {...props} />
));
DialogOverlay.displayName = Modal.Overlay.displayName;

type DialogDescriptionProps = React.HTMLAttributes<HTMLParagraphElement>;

const DialogDescription = forwardRef<HTMLParagraphElement, DialogDescriptionProps>(({ className, ...props }, ref) => <Modal.Description ref={ref} className={twMerge('text-sm text-muted-foreground', className)} {...props} />);

DialogDescription.displayName = Modal.Description.displayName;

export const ModalFooter = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => <div className={twMerge('flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2', className)} {...props} />;
ModalFooter.displayName = 'ModalFooter';
export const ModalContentVideo = ({ children, ...props }: ModalProps) => {
	// const extractedChildren = Children.toArray(children);
	// const modalTitle = extractedChildren.find((child) => isValidElement(child) && child.type === ModalTitle);
	// const modalFooter = extractedChildren.find((child) => isValidElement(child) && child.type === ModalFooter);

	// const remainingChildren = extractedChildren.filter((child) => !(isValidElement(child) && [ModalTitle, ModalFooter].includes(child.type as never)));

	return (
		<>
			<Modal.Portal>
				<DialogOverlay />
				<Modal.Content
					{...props}
					className={twMerge(
						'!outline-0 custom-scroll fixed left-[50%] top-[50%] h-[80vh] overflow-hidden rounded-lg z-50 bg-transparent grid w-3/6 translate-x-[-50%] translate-y-[-50%] gap-4 border-0 p-4 pr-1 pt-8 duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%]',
						props.className
					)}>
					{children}

					{/* <div className='border-b p-4 pt-0'>{modalTitle}</div>

                    <div className={twMerge('overflow-y-auto custom-scroll pr-1 h-5/6', props.contentClass)}>{remainingChildren}</div>

                    <div className='bg-white p-4 border-t'>{modalFooter}</div> */}

					{/* <Modal.Close asChild>
						<button className='absolute box-content bg-white p-2 flex right-2.5 top-2.5 size-[20px] appearance-none items-center justify-center rounded-full text-gray-900 outline-none' aria-label='Close'>
							<XMarkIcon />
						</button>
					</Modal.Close> */}
				</Modal.Content>
			</Modal.Portal>
		</>
	);
};

interface ModalTriggerProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	children: ReactNode;
}

export const ModalTriggerVideo = ({ children, ...props }: ModalTriggerProps) => {
	return (
		<Modal.Trigger asChild {...props}>
			{children}
		</Modal.Trigger>
	);
};
